import GridAction from '../../components/common/GridAction';
import { AppPermissions } from '../../constants/Permissions';
import { Facility } from '../../types/Facility';
import { dateHeader, formatCellDate } from './timeModeCell';
import MyLocationOutlined from '@mui/icons-material/MyLocationOutlined';

export const makeNearFacilityColumn = (onDeleted: (id: string) => void, onEdit: (facility: Facility) => void) => {
  return [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const { id } = row.original as Facility;
        return (
          <GridAction
            onEdit={onEdit}
            editPermission={AppPermissions.Facility.Edit}
            onDeleted={onDeleted}
            deletePermission={AppPermissions.Facility.Delete}
            row={row.original}
            id={id}
          />
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 350,
      cell: ({ row }) => <span title={row.original.name}>{row.original.name}</span>,
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
    },
    {
      header: 'Type',
      accessorKey: 'facilityType',
      size: 100,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return <>{row.original.facilityTypeDescr ?? '-'}</>;
      },
    },
    {
      header: 'Fence',
      accessorKey: 'geofences',
      disableSortBy: true,
      size: 55,
      cell: ({ row }) => {
        return (
          <MyLocationOutlined
            fontSize='small'
            style={{ marginLeft: 10, color: row.original.geofences && row.original.geofences.length > 0 ? 'red' : 'black' }}
          />
        );
      },
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      sortable: false,
      enableColumnFilter: false,
      style: { textAlign: 'left' },
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;
};
